var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"run-substate"},[(_vm.substate != null)?_c('StateProcess',{attrs:{"title":this.getSubstateDescription(_vm.substate)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }